<template>
  <div>
    <PageHeaderLayout>
      <div class="main-page-content">
        <!-- 操作按钮区域 -->
        <el-row class="table-header">
          <el-col>
            <div class="action-buttons">
              <el-button 
                type="primary" 
                size="medium" 
                icon="el-icon-upload2" 
                @click="triggerFileUpload" 
                :disabled="loadingStaus"
                class="action-btn">
                <span>导入数据</span>
              </el-button>
              <input type="file" accept=".xlsx" ref="fileInput" @change="handleFileUpload" style="display: none;" />
              
              <el-button 
                type="success" 
                size="medium" 
                icon="el-icon-download" 
                @click="downloadButton()"
                class="action-btn">
                <span>导出数据</span>
              </el-button>
              
              <el-tooltip effect="dark" content="添加新的包裹规格" placement="top">
                <el-button 
                  type="primary" 
                  size="medium" 
                  icon="el-icon-plus" 
                  @click="addButton()"
                  class="action-btn add-btn">
                  <span>添加规格</span>
                </el-button>
              </el-tooltip>
            </div>
          </el-col>
        </el-row>

        <!-- 搜索区域 -->
        <div class="search-section">
          <el-card shadow="never" class="search-card">
            <el-form size="medium" :inline="true" :model="searchCondition" class="search-form">
              <el-form-item label="宽度(mm)" class="search-item">
                <el-input 
                  v-model="searchCondition.width" 
                  placeholder="请输入宽度" 
                  clearable
                  prefix-icon="el-icon-rank"
                  class="search-input">
                </el-input>
              </el-form-item>
              
              <el-form-item label="高度(mm)" class="search-item">
                <el-input 
                  v-model="searchCondition.height" 
                  placeholder="请输入高度" 
                  clearable
                  prefix-icon="el-icon-sort"
                  class="search-input">
                </el-input>
              </el-form-item>
              
              <el-form-item label="长度(mm)" class="search-item">
                <el-input 
                  v-model="searchCondition.length" 
                  placeholder="请输入长度" 
                  clearable
                  prefix-icon="el-icon-menu"
                  class="search-input">
                </el-input>
              </el-form-item>
              
              <el-form-item class="search-actions">
                <el-button 
                  type="primary" 
                  @click="getList"
                  icon="el-icon-search"
                  class="search-btn">
                  查询
                </el-button>
                <el-button 
                  @click="resetSearch"
                  icon="el-icon-refresh"
                  class="reset-btn">
                  重置
                </el-button>
              </el-form-item>
            </el-form>
          </el-card>
        </div>

        <!-- 数据表格区域 -->
        <div class="table-section">
          <el-card shadow="never" class="table-card">
            <ApeTable 
              ref="apeTable" 
              :data="dataList"  
              :loading="loadingStaus" 
              :pagingData="pagingData" 
              @switchPaging="switchPaging" 
              highlight-current-row 
              border
              class="data-table">
              
              <el-table-column
                label="长度"
                prop="length"
                align="center">
                <template slot-scope="scope">
                  <div class="dimension-cell">
                    <i class="el-icon-menu cell-icon"></i>
                    <span class="dimension-value">{{scope.row.length}}</span>
                    <span class="dimension-unit">mm</span>
                  </div>
                </template>
              </el-table-column>
              
              <el-table-column
                label="宽度"
                prop="width"
                align="center">
                <template slot-scope="scope">
                  <div class="dimension-cell">
                    <i class="el-icon-rank cell-icon"></i>
                    <span class="dimension-value">{{scope.row.width}}</span>
                    <span class="dimension-unit">mm</span>
                  </div>
                </template>
              </el-table-column>
              
              <el-table-column
                label="高度"
                prop="height"
                align="center">
                <template slot-scope="scope">
                  <div class="dimension-cell">
                    <i class="el-icon-sort cell-icon"></i>
                    <span class="dimension-value">{{scope.row.height}}</span>
                    <span class="dimension-unit">mm</span>
                  </div>
                </template>
              </el-table-column>
              
              <el-table-column
                label="体积"
                prop="volume"
                align="center">
                <template slot-scope="scope">
                  <div class="volume-cell">
                    <i class="el-icon-box cell-icon"></i>
                    <span class="volume-value">{{scope.row.volume}}</span>
                    <span class="volume-unit">mm³</span>
                  </div>
                </template>
              </el-table-column>
              
              <el-table-column
                label="状态"
                prop="package_status"
                align="center">
                <template slot-scope="scope">
                  <el-switch
                    v-model="scope.row.package_status"
                    @change="changeStatus(scope.row)"
                    active-value="1"
                    inactive-value="0"
                    active-color="#67C23A"
                    inactive-color="#F56C6C"
                    active-text="启用"
                    inactive-text="禁用">
                  </el-switch>
                </template>
              </el-table-column>
              
              <el-table-column
                v-if="buttonType=='icon'"
                label="操作"
                align="center"
                fixed="right">
                <template slot-scope="scope">
                  <div class="operation-buttons">
                    <el-tooltip effect="dark" content="编辑规格信息" placement="top">
                      <el-button 
                        size="mini" 
                        type="primary"
                        icon="el-icon-edit" 
                        @click="editButton(scope.row.id)"
                        class="op-btn">
                      </el-button>
                    </el-tooltip>
                  </div>
                </template>
              </el-table-column>
            </ApeTable>
          </el-card>
        </div>
      </div>
    </PageHeaderLayout>

    <!-- 编辑弹窗 -->
    <ApeDrawer :drawerData="drawerData"  @drawerClose="drawerClose" @drawerConfirm="drawerConfirm">
      <template slot="ape-drawer">
        <div class="form-container">
          <el-form 
            :model="formData" 
            :rules="rules" 
            ref="dataForm" 
            label-position="left" 
            label-width="100px"
            class="drawer-form">
            
            <el-form-item label="长度(mm)" prop="length">
              <el-input 
                v-model="formData.length" 
                placeholder="请输入长度，单位：毫米"
                prefix-icon="el-icon-menu"
                type="number">
              </el-input>
            </el-form-item>
            
            <el-form-item label="宽度(mm)" prop="width">
              <el-input 
                v-model="formData.width" 
                placeholder="请输入宽度，单位：毫米"
                prefix-icon="el-icon-rank"
                type="number">
              </el-input>
            </el-form-item>
            
            <el-form-item label="高度(mm)" prop="height">
              <el-input 
                v-model="formData.height" 
                placeholder="请输入高度，单位：毫米"
                prefix-icon="el-icon-sort"
                type="number">
              </el-input>
            </el-form-item>
            
            <el-form-item label="启用状态" prop="package_status">
              <el-switch 
                v-model="formData.package_status" 
                active-value="1" 
                inactive-value="0"
                active-color="#67C23A"
                inactive-color="#F56C6C"
                active-text="启用"
                inactive-text="禁用">
              </el-switch>
            </el-form-item>
            
            <!-- 体积预览 -->
            <el-form-item label="体积预览">
              <div class="volume-preview">
                <i class="el-icon-box preview-icon"></i>
                <span class="preview-text">
                  {{(formData.length || 0) * (formData.width || 0) * (formData.height || 0)}} mm³
                </span>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </template>
    </ApeDrawer>
  </div >
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'
import ApeDrawer from '@/components/ApeDrawer'
import { mapGetters } from 'vuex'
import ApeUploader from '@/components/ApeUploader'
import * as XLSX from 'xlsx';
export default {
  components: {
    PageHeaderLayout,
    ApeTable,
    ApeDrawer,
    ApeUploader
  },
  data() {
    return {
      // 搜索条件
      searchCondition:{
        current_page: 1,
        page_size: 20,
        length:'',
        width:'',
        height:'',
        query: "",
        params: [],
      },
      loadingStaus: true,
      // 表格列表数据
      dataList:[],
      // 分页信息
      pagingData:{
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0
      },
      // 分页的offset,序号列使用
      offset:0,
      region_info:{
        region:0,
      },
      // 表单结构
      formData: {
        id:0,
      },
      // 表单验证
      rules: {
        length: [{required: true,message:'输入长度', trigger: 'blur' }],
        width: [{required: true,message:'输入宽度', trigger: 'blur' }],
        height: [{required: true,message:'输入高度', trigger: 'blur' }],
      },
      // 抽屉数据
      drawerData: {
        visible: false,
        loading: true,
        loading_text: '玩命加载中……',
        title: '权限绑定',
        width_height: '480',
      },
    }
  },
  computed: {
    ...mapGetters(['userPermissions','buttonType'])
  },
  methods: {
    // 重置搜索
    resetSearch() {
      this.searchCondition.width = ''
      this.searchCondition.height = ''
      this.searchCondition.length = ''
      this.getList()
    },
    getNode(id){
      window.open('/express/'+id+'/address_node','_blank')
    },
    async changeStatus(row){
      let res = await this.$api.post('/service/ola_app_express_package/update',row)
      if (this.$apiSuccess(res)){
        this.$message.success('状态修改成功!')
      }
    },
    // 搜索
    setSearchCondition() {     
      this.searchCondition.query = ''
      this.searchCondition.params = []
      if (this.searchCondition.width != ''){
        this.searchCondition.query != '' ? this.searchCondition.query += ' and width=?' : this.searchCondition.query += ' width=?'
        this.searchCondition.params.push(this.searchCondition.width)
      }
      if (this.searchCondition.height != ''){
        this.searchCondition.query != '' ? this.searchCondition.query += ' and height=?' : this.searchCondition.query += ' height=?'
        this.searchCondition.params.push(this.searchCondition.height)
      }
      if (this.searchCondition.length != ''){
        this.searchCondition.query != '' ? this.searchCondition.query += ' and length=?' : this.searchCondition.query += ' length=?'
        this.searchCondition.params.push(this.searchCondition.length)
      }
    },
    triggerFileUpload() {
      this.loadingStaus = true
      this.$refs.fileInput.click()
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: 'array' });
          // 处理工作簿内容
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];
          const jsonData = XLSX.utils.sheet_to_json(worksheet);
          this.importData(jsonData)
        };
        reader.readAsArrayBuffer(file);
      }
    },
    async importData(jsonData) {
      let datas = jsonData.map(item => ({
          "width": item.宽度,
          "height": item.高度,
          "length": item.长度,
          "volume": item.宽度*item.高度*item.长度,
          "package_status": item.状态=='启用'?'1':'0'
      }));
      let res = await this.$api.post('/service/ola_app_express_package/import',{datas:datas,unique_key:"width,height,length"})
      if (this.$apiSuccess(res)){
        this.$message.success('导入成功!')
        this.getList()
      }else{
        this.$message.error(res.message)
      }
      this.loadingStaus = false
    },
    // 切换页码操作
    async switchPaging() {
      this.getList()
    },
    // 响应添加按钮
    async addButton() {
      this.drawerData.visible = true
      this.drawerData.title = '添加数据'
      this.drawerData.loading = false
    },
    // 响应编辑按钮
    async editButton(id) {
      this.drawerData.loading_text = '玩命加载中……'
      this.drawerData.visible = true
      this.drawerData.title = '编辑数据(UID：'+id+')'
      let res = await this.$api.post('/service/ola_app_express_package/detail',{id:id})
      if (this.$apiSuccess(res)){
        this.formData = res.data.detail
      }else{
        this.$message.error(res.message)
      }
      this.drawerData.loading = false
    },
    // 处理抽屉关闭
    drawerClose() {
      this.initFormData()
      this.drawerData.visible = false
      this.drawerData.loading = true
    },
    // 处理抽屉确认
    async drawerConfirm() {
      // 调用组件的数据验证方法
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.formSubmit()
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
    },
    // form数据提交，请求接口
    async formSubmit() {
      this.formData.volume = this.formData.width * this.formData.height * this.formData.length
      this.drawerData.loading_text = '玩命提交中……'
      this.drawerData.loading = true
      let url = '/service/ola_app_express_package/create'
      if(this.formData.id!=''){
        url = '/service/ola_app_express_package/update'
      }
      let res = await this.$api.post(url,this.formData)
      if (this.$apiSuccess(res)){
        this.$message.success('保存成功!')
        this.formData = res.data.detail
      }else{
        this.$message.error(res.message)
      }
      this.drawerData.loading = false
      this.drawerData.visible = false
    },
    // 相应删除按钮
    async deleteButton(id) {
      let info = await this.$api.post('/service/ola_app_express_package/delete',{id:id})
      if (info == null) {
        this.$message.success('删除成功!')
        this.$nextTick(async () => {
          this.getList()
        })
      } else {
        this.$message.error(info)
      }
      
    },
    // 初始化数据
    initFormData() {
      // 初始化form表单
      this.$nextTick(() => {
        this.formData = {id:0}
        this.$refs['dataForm'].resetFields()
      })
    },
    // 初始化数据列表
    async getList() {
      this.loadingStaus=true
      this.setSearchCondition()
      Object.assign(this.searchCondition,this.$refs['apeTable'].getPagingInfo())
      let res = await this.$api.post('/service/ola_app_express_package/list',this.searchCondition)
      if (this.$apiSuccess(res)){
        this.dataList = res.data.list
        this.pagingData.total = res.data.page.total 
      }else{
        this.dataList = []
        this.pagingData.total = 0
        this.$message.error(res.message)
      } 
      this.loadingStaus=false
    },
    async uploadButton() {
      console.log('uploadButton')
    },
    async downloadButton() {
      let searchCondition = this.searchCondition
      delete searchCondition.page_size
      delete searchCondition.current_page
      let res = await this.$api.post('/service/ola_app_express_package/list',searchCondition)
      if (this.$apiSuccess(res)){
        let data = res.data.list
        const filteredData = data.map(item => ({
          "宽度": item.width,
          "高度": item.height,
          "长度": item.length,
          "体积": item.volume,
          "状态": item.package_status=='1'?'启用':'禁用'
        }));
        const worksheet = XLSX.utils.json_to_sheet(filteredData, {
          header: ['宽度', '高度', '长度', '体积', '状态']
        });
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, '包裹管理');
        XLSX.writeFile(workbook, '包裹管理.xlsx');
      }else{
        this.$message.error(res.message)
      }
      this.loadingStaus = false
    },
  },
  mounted() {
    this.getList()
  },
}
</script>

<style lang="stylus" scoped>
// 页面标题样式
.page-title-section
  margin-bottom 24px
  padding 16px 0
  border-bottom 1px solid #E4E7ED
  
  .page-title
    font-size 24px
    font-weight 600
    color #303133
    margin 0 0 8px 0
    
  .page-subtitle
    font-size 14px
    color #909399
    margin 0

// 操作按钮区域样式
.table-header
  margin-bottom 16px
  
  .action-buttons
    display flex
    gap 12px
    
    .action-btn
      display flex
      align-items center
      gap 8px
      padding 10px 16px
      border-radius 6px
      transition all 0.3s ease
      
      &:hover
        transform translateY(-1px)
        box-shadow 0 4px 12px rgba(0,0,0,0.15)
        
    .add-btn
      background linear-gradient(135deg, #409EFF 0%, #67C23A 100%)
      border none
      
      &:hover
        background linear-gradient(135deg, #337ecc 0%, #529b2e 100%)

// 搜索区域样式
.search-section
  margin-bottom 16px
  
  .search-card
    border-radius 8px
    box-shadow 0 2px 8px rgba(0,0,0,0.1)
    
    .search-form
      .search-item
        margin-right 24px
        margin-bottom 0
        
        .search-input
          width 150px
          
      .search-actions
        margin-right 0
        
        .search-btn
          background #409EFF
          border-color #409EFF
          padding 8px 20px
          
        .reset-btn
          margin-left 8px
          padding 8px 16px

// 表格区域样式  
.table-section
  .table-card
    border-radius 8px
    box-shadow 0 2px 8px rgba(0,0,0,0.1)
    
    .data-table
      /deep/ .el-table
        border-radius 8px
        overflow hidden
        
        th
          background #F5F7FA
          color #606266
          font-weight 600
          
        .dimension-cell
          display flex
          align-items center
          justify-content center
          gap 4px
          
          .cell-icon
            color #409EFF
            font-size 14px
            
          .dimension-value
            color #303133
            font-weight 500
            
          .dimension-unit
            color #909399
            font-size 12px
            
        .volume-cell
          display flex
          align-items center
          justify-content center
          gap 4px
          
          .cell-icon
            color #E6A23C
            font-size 14px
            
          .volume-value
            color #303133
            font-weight 600
            
          .volume-unit
            color #909399
            font-size 12px
            
        .operation-buttons
          display flex
          gap 8px
          justify-content center
          
          .op-btn
            padding 4px 8px
            border-radius 4px
            
            &:hover
              transform scale(1.1)

// 抽屉表单样式
.form-container
  padding 20px
  
  .drawer-form
    /deep/ .el-form-item
      margin-bottom 24px
      
      .el-form-item__label
        font-weight 600
        color #606266
        
      .el-input
        .el-input__inner
          border-radius 6px
          border-color #DCDFE6
          transition all 0.3s ease
          
          &:focus
            border-color #409EFF
            box-shadow 0 0 0 2px rgba(64,158,255,0.2)
            
    .volume-preview
      display flex
      align-items center
      gap 8px
      padding 12px 16px
      background #F5F7FA
      border-radius 6px
      border 1px solid #E4E7ED
      
      .preview-icon
        color #E6A23C
        font-size 18px
        
      .preview-text
        color #303133
        font-weight 600
        font-size 16px
</style>
